import React from 'react'
import './rsvp.css'
import MOON from '../../assets/moon.svg'
import METEOR from '../../assets/meteor.svg'

const Rsvp = () => {
  return (
      <section>
        <div id='rsvp'><br/><br/><br/></div>
        <div className="container attend__container">
          <div className='rsvp_content'>
            <img src={MOON} className="moon-graphic" alt="moon" />
            <div className='rsvp_column'>
              <iframe
                title="EPIC 2025 registration form"
                className='rsvp_embed'
                src="https://docs.google.com/forms/d/e/1FAIpQLSdMyclrLa4IAhUQSmjlH28syCnNmZRww53JY9e53uHPYbPNJQ/viewform?embedded=true"
                width="100%"
                height="500vw"
                frameBorder="0"
                marginHeight="0"
                marginWidth="0"
              >
                Loading…
              </iframe>
            </div>
            <div className='rsvp_column'>
              <h2 className="rsvp_title">register for EPIC 2025</h2>
              <p> EPIC 2025 will be taking place on Wednesday, April 9, 2024, from 5:00 PM to 8:30 PM PT at the Bruin Reception Room </p>
              <p> Registration is free and open to all UCLA students. </p>
              <a
                className="rsvp_link"
                href="https://forms.gle/D6oxa3GctyxpBYNfA"
                target="_blank"
                rel="noreferrer"
              >
                RSVP
              </a>
            </div>
          </div>
        </div>
        <img src={METEOR} className="meteor-graphic" alt="meteor" />
      </section>
  )
}

export default Rsvp